<div class="reset-shell">
  <div class="reset-card">
    <div class="logo-badge">
      <img src="/brand/inbordo-logo.svg" alt="InBordo" />
    </div>
    <h1>{{ 'auth.reset.title' | translate }}</h1>
    <p>{{ 'auth.reset.subtitle' | translate }}</p>

    <label>
      {{ 'auth.reset.email' | translate }}
      <input type="email" [(ngModel)]="email" name="email" placeholder="name@company.com" />
    </label>

    <button class="primary" type="button">{{ 'auth.reset.send' | translate }}</button>
    <a routerLink="/login" class="ghost">{{ 'auth.reset.back' | translate }}</a>
  </div>
</div>
